import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        gap: 4
    },
    button: {
        textTransform: 'uppercase',
        padding: '6px 12px',
        fontWeight: 400,
        fontSize: 12,
        color: '#38383A',
        minWidth: 34,
        minHeight: 34,
        borderRadius: 8,
        transition: 'all 0.2s',
        '&:hover': {
            borderColor: theme.palette.primary.light,
            color: theme.palette.primary.light,
            backgroundColor: 'transparent'
        }
    },
    _selected: {
        cursor: 'default',
        pointerEvents: 'none',
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.light,
        color: '#fff',
        fontWeight: 700,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.light,
            color: '#fff',
            fontWeight: 700
        }
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 0',
        width: '100%'
    }
}));
